// MusicFlow StudioAi brand assets — full logo (emblem + wordmark + tagline) and emblem-only mark.
export const APP_NAME = "MusicFlow StudioAi";

export const LogoMark = ({ size = 24, className = "" }) => (
  <img
    src="/logo-mark.png"
    width={size}
    height={size}
    alt={APP_NAME}
    className={`rounded-md object-contain shrink-0 ${className}`}
    data-testid="brand-logo-mark"
  />
);

// Full logo, always shown in its entirety (object-contain). `width` controls the rendered width.
export const LogoFull = ({ width = 220, className = "" }) => (
  <img
    src="/logo-full.png"
    alt={`${APP_NAME} — Generate. Adapt. Play.`}
    style={{ width, height: "auto" }}
    className={`object-contain select-none ${className}`}
    data-testid="brand-logo-full"
  />
);

export const Logo = ({ iconSize = 24, textClassName = "text-xl", showText = true, className = "" }) => (
  <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
    <LogoMark size={iconSize} />
    {showText && (
      <span className={`font-display font-extrabold tracking-tight leading-none ${textClassName}`}>
        MusicFlow <span className="bg-gradient-to-r from-[#7C3AED] via-[#3B82F6] to-[#06B6D4] bg-clip-text text-transparent">StudioAi</span>
      </span>
    )}
  </div>
);
